{
  "name": "shaas21-pillars",
  "version": "1.0.6",
  "scripts": {
    "ng": "ng",
    "version-patch": "npm version patch",
    "version-minor": "npm version minor",
    "version-major": "npm version major",
    "start": "npx kill-port 4200 && npm run prebuild && ng serve --configuration=local",
    "start:e2e": "npx kill-port 4200 && npm run prebuild && ng serve --configuration=e2e",
    "start:choose": "node scripts/start-interactive.mjs",
    "start:prod": "npx kill-port 4200 && npm run prebuild && ng serve --configuration=production",
    "start:stg": "npx kill-port 4200 && npm run prebuild && ng serve --configuration=stg",
    "start:prod-local": "npx kill-port 4200 && ng serve --configuration=prod-local",
    "local": "npm run prebuild && ng serve --configuration=local",
    "local-auto": "ng serve --configuration=local",
    "trav": "npx kill-port 4200 && npm run prebuild && ng serve --configuration=trav",
    "build": "ng build && npm run upload:sourcemaps",
    "build:dev": "ng build --configuration=development",
    "build:stg": "ng build --configuration=stg",
    "build:prod": "ng build --configuration=production && npm run upload:sourcemaps",
    "upload:sourcemaps": "posthog-cli --dotenv-file .env sourcemap process --directory ./dist/shaas21-pillars/browser --release-name shaas21-pillars --delete-after",
    "prebuild": "node src/scripts/write-version.js",
    "watch": "ng build --watch --configuration development",
    "test": "ng test",
    "e2e": "cypress run",
    "e2e:open": "cypress open",
    "e2e:headed": "cypress run --headed --browser chrome",
    "e2e:ci": "cypress run --browser chrome --config video=true --spec 'cypress/e2e/**/*.cy.ts'",
    "e2e:smoke": "cypress run --browser chrome --spec 'cypress/e2e/smoke/**/*.cy.ts'",
    "e2e:daily": "cypress run --browser chrome --spec 'cypress/daily/daily-smoke.cy.ts' --config retries=0; node scripts/report-daily-tests.mjs",
    "storybook": "ng run shaas21-pillars:storybook",
    "build-storybook": "ng run shaas21-pillars:build-storybook"
  },
  "prettier": {
    "printWidth": 100,
    "singleQuote": true,
    "overrides": [
      {
        "files": "*.html",
        "options": {
          "parser": "angular"
        }
      }
    ]
  },
  "private": true,
  "packageManager": "npm@11.6.2",
  "dependencies": {
    "@angular/animations": "21.2.24",
    "@angular/cdk": "^21.2.4",
    "@angular/common": "21.2.24",
    "@angular/compiler": "21.2.24",
    "@angular/core": "21.2.24",
    "@angular/forms": "21.2.24",
    "@angular/material": "^21.2.4",
    "@angular/platform-browser": "21.2.24",
    "@angular/router": "21.2.24",
    "@deltalaboratory/uuid": "^0.3.3",
    "@firebase/storage": "^0.14.0",
    "@fortawesome/angular-fontawesome": "^4.0.0",
    "@fortawesome/fontawesome-svg-core": "^7.2.0",
    "@fortawesome/free-brands-svg-icons": "^7.2.0",
    "@fortawesome/free-regular-svg-icons": "^7.2.0",
    "@fortawesome/free-solid-svg-icons": "^7.2.0",
    "@microsoft/clarity": "^1.0.2",
    "@ngx-translate/core": "^17.0.0",
    "@omnedia/ngx-border-beam": "^4.0.1",
    "@omnedia/ngx-connection-beam": "^4.0.1",
    "@omnedia/ngx-flickering-grid": "^4.0.1",
    "@omnedia/ngx-galaxy": "^4.0.1",
    "@omnedia/ngx-highlighter": "^4.0.1",
    "@omnedia/ngx-light-rays": "^4.0.1",
    "@omnedia/ngx-orb": "^4.0.1",
    "@omnedia/ngx-shine-border": "^4.0.1",
    "@omnedia/ngx-split-text": "^4.0.1",
    "@omnedia/ngx-typewriter": "^4.0.1",
    "@omnedia/ngx-vortex": "^4.0.1",
    "@tailwindplus/elements": "^1.0.21",
    "bowser": "^2.13.1",
    "date-fns": "^4.1.0",
    "date-fns-tz": "^3.2.0",
    "echarts": "^6.0.0",
    "firebase": "^12.7.0",
    "gsap": "^3.14.2",
    "hls.js": "^1.6.15",
    "jspdf": "^4.2.1",
    "jspdf-autotable": "^5.0.7",
    "lottie-web": "^5.13.0",
    "ngx-device-detector": "^11.0.0",
    "ngx-echarts": "^21.0.0",
    "ngx-editor": "^19.0.0-beta.1",
    "ngx-filesaver": "^21.0.0",
    "ngx-float-ui": "^21.0.1",
    "ngx-infinite-scroll": "^21.0.0",
    "ngx-lottie": "^21.2.0",
    "ogl": "^1.0.11",
    "openai": "^6.31.0",
    "posthog-js": "^1.436.1",
    "rough-notation": "^0.5.1",
    "rxjs": "~7.8.0",
    "stream-chat": "^9.28.0",
    "stream-chat-angular": "^7.1.2",
    "tailwindcss": "^4.1.18",
    "tslib": "^2.3.0"
  },
  "devDependencies": {
    "@analogjs/vite-plugin-angular": "^2.5.2",
    "@angular-devkit/architect": "0.2102.24",
    "@angular-devkit/core": "21.2.24",
    "@angular/build": "21.2.24",
    "@angular/cli": "21.2.24",
    "@angular/compiler-cli": "21.2.24",
    "@chromatic-com/storybook": "latest",
    "@inquirer/prompts": "^7.10.1",
    "@posthog/cli": "^0.18.9",
    "@storybook/addon-a11y": "^10.6.1",
    "@storybook/addon-docs": "^10.6.1",
    "@storybook/addon-onboarding": "^10.6.1",
    "@storybook/addon-vitest": "^10.6.1",
    "@storybook/angular-vite": "^10.6.1",
    "@tailwindcss/postcss": "^4.1.12",
    "@types/node": "^20",
    "@vitest/browser-playwright": "4.0.16",
    "@vitest/coverage-v8": "4.0.16",
    "cypress": "^15.12.0",
    "jsdom": "^27.1.0",
    "playwright": "latest",
    "postcss": "^8.5.3",
    "storybook": "^10.6.1",
    "tailwindcss": "^4.1.12",
    "typescript": "~5.9.2",
    "vite": "latest",
    "vitest": "^4.0.8"
  }
}
